import { render, staticRenderFns } from "./SearchHeader.vue?vue&type=template&id=34ce3bc0&scoped=true&"
import script from "./SearchHeader.vue?vue&type=script&lang=js&"
export * from "./SearchHeader.vue?vue&type=script&lang=js&"
import style0 from "./SearchHeader.vue?vue&type=style&index=0&id=34ce3bc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ce3bc0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34ce3bc0')) {
      api.createRecord('34ce3bc0', component.options)
    } else {
      api.reload('34ce3bc0', component.options)
    }
    module.hot.accept("./SearchHeader.vue?vue&type=template&id=34ce3bc0&scoped=true&", function () {
      api.rerender('34ce3bc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/modules/search/components/SearchHeader.vue"
export default component.exports